import { Injectable } from '@angular/core';
import {ApiService} from "../../../core/services/api/api.service";
import {Observable} from "rxjs";
import {Notification} from "../../../models/notification";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private apiService: ApiService) { }

  getNotifications(studyId: number, moduleId: number): Observable<Notification[]> {
    return this.apiService.get<Notification[]>(`/dashboard/study/${studyId}/module/${moduleId}/notifications`);
  }

  getNotificationById(studyId: number, moduleId: number, notificationId: number): Observable<Notification> {
    return this.apiService.get<Notification>(`/dashboard/study/${studyId}/module/${moduleId}/notification/${notificationId}`);
  }

  createNotification(studyId: number, moduleId: number, notification: Notification): Observable<Notification> {
    return this.apiService.post<Notification>(`/dashboard/study/${studyId}/module/${moduleId}/notification`, notification);
  }

  updateNotification(studyId: number, moduleId: number, notificationId: number, notification: Notification): Observable<Notification> {
    return this.apiService.put<Notification>(`/dashboard/study/${studyId}/module/${moduleId}/notification/${notificationId}`, notification);
  }

  deleteNotificationById(studyId: number, moduleId: number, notificationId: number): Observable<Notification> {
    return this.apiService.delete<Notification>(`/dashboard/study/${studyId}/module/${moduleId}/notification/${notificationId}`);
  }
}
